import React, { useMemo, useRef, useState } from "react";
import { ColDef, ColumnState, RowClickedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
import { PDA1070_R01HeaderDto } from "./PDA1070_R01Dto";
import {
  aggridHeaderClass,
  pdaCellStyle,
} from "src/components/common/common";

interface PDA1070_R01TableProps {
  workOrderList: PDA1070_R01HeaderDto[];
  onSelectWorkOrder: (order: PDA1070_R01HeaderDto) => void;
}

type PDA1070_R01HeaderDtoWithInserted = PDA1070_R01HeaderDto & { inserted?: boolean };

const PDA1070_R01Table: React.FC<PDA1070_R01TableProps> = ({
  workOrderList,
  onSelectWorkOrder,
}) => {
  const gridRef = useRef<AgGridReact<PDA1070_R01HeaderDtoWithInserted>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);
  const [columnState, setColumnState] = useState<ColumnState[] | null>(null);

  const paddedGridData = useMemo(() => [...workOrderList], [workOrderList]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "일자",
        field: "workDt",
        valueGetter: (params: { data?: PDA1070_R01HeaderDto }) => {
          const dateStr = params.data?.workDt;
          if (!dateStr) return "-";
          const parts = String(dateStr).split("-");
          if (parts.length >= 3) return `${parts[1]}-${parts[2]}`;
          return dateStr;
        },
        cellStyle: {
          textAlign: "center",
          ...pdaCellStyle,
          justifyContent: "center",
        },
        headerClass: aggridHeaderClass,
        flex: 0.7,
        minWidth: 90,
      },
      {
        headerName: "코드",
        field: "productWorkNo",
        valueGetter: (params: { data?: PDA1070_R01HeaderDto }) =>
          params.data?.productWorkNo ?? "-",
        cellStyle: {
          textAlign: "left",
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 90,
      },
      {
        headerName: "품명",
        field: "itemNm",
        valueGetter: (params: { data?: PDA1070_R01HeaderDto }) =>
          params.data?.itemNm ?? "-",
        cellStyle: {
          textAlign: "left",
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 1.5,
        minWidth: 90,
      },
      {
        headerName: "규격",
        field: "itemSpec",
        valueGetter: (params: { data?: PDA1070_R01HeaderDto }) =>
          params.data?.itemSpec ?? "-",
        cellStyle: {
          textAlign: "left",
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 2,
        minWidth: 80,
      },
    ] as ColDef<PDA1070_R01HeaderDtoWithInserted>[],
    []
  );

  const handleRowClicked = (event: RowClickedEvent<PDA1070_R01HeaderDtoWithInserted>) => {
    if (event.data) onSelectWorkOrder(event.data);
  };

  const initSelected = () => {};

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper<PDA1070_R01HeaderDtoWithInserted>
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={initSelected}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1070_R01_Table_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<PDA1070_R01HeaderDtoWithInserted>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1070_R01_Table_ColumnState"
            setColumnState={setColumnState}
            onRowClicked={handleRowClicked}
          />
        </div>
      </GridContextWrapper>
    </div>
  );
};

export default PDA1070_R01Table;
